// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";
import * as PaymentConfirmTypesV2$OrcaPaymentPage from "../Types/PaymentConfirmTypesV2.bs.js";

function getCardDetails(cardDict) {
  return {
    network: Utils$OrcaPaymentPage.getOptionString(cardDict, "card_network"),
    last4Digits: Utils$OrcaPaymentPage.getString(cardDict, "last4_digits", ""),
    expiryMonth: Utils$OrcaPaymentPage.getString(cardDict, "expiry_month", ""),
    expiryYear: Utils$OrcaPaymentPage.getString(cardDict, "expiry_year", ""),
    cardHolderName: Utils$OrcaPaymentPage.getOptionString(cardDict, "card_holder_name"),
    nickname: Utils$OrcaPaymentPage.getOptionString(cardDict, "nick_name"),
    issuerCountry: Utils$OrcaPaymentPage.getOptionString(cardDict, "card_issuer"),
    cardFingerprint: Utils$OrcaPaymentPage.getString(cardDict, "card_fingerprint", ""),
    cardIsin: Utils$OrcaPaymentPage.getString(cardDict, "card_isin", ""),
    cardIssuer: Utils$OrcaPaymentPage.getString(cardDict, "card_issuer", ""),
    cardType: Utils$OrcaPaymentPage.getString(cardDict, "card_type", ""),
    savedToLocker: Utils$OrcaPaymentPage.getBool(cardDict, "saved_to_locker", false)
  };
}

function itemToCustomerMapper(customerArray) {
  return Belt_Array.keepMap(customerArray, Core__JSON.Decode.object).map(dict => {
    let cardDict = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(dict, "payment_method_data"), "card");
    return {
      paymentToken: Utils$OrcaPaymentPage.getString(dict, "payment_method_token", ""),
      customerId: Utils$OrcaPaymentPage.getString(dict, "customer_id", ""),
      paymentMethodType: Utils$OrcaPaymentPage.getString(dict, "payment_method_type", ""),
      paymentMethodSubType: Utils$OrcaPaymentPage.getString(dict, "payment_method_subtype", ""),
      recurringEnabled: Utils$OrcaPaymentPage.getBool(dict, "recurring_enabled", false),
      paymentMethodData: {
        card: getCardDetails(cardDict)
      },
      isDefault: Utils$OrcaPaymentPage.getBool(dict, "is_default", false),
      requiresCvv: Utils$OrcaPaymentPage.getBool(dict, "requires_cvv", false),
      lastUsedAt: Utils$OrcaPaymentPage.getString(dict, "last_used_at", ""),
      created: Utils$OrcaPaymentPage.getString(dict, "created", ""),
      bank: {
        mask: ""
      }
    };
  });
}

function getDynamicFieldsFromJsonDictV2(dict, isBancontact) {
  let requiredFields = Utils$OrcaPaymentPage.getArray(dict, "required_fields");
  return requiredFields.map(requiredField => {
    let requiredFieldsDict = Utils$OrcaPaymentPage.getDictFromJson(requiredField);
    return {
      required_field: Utils$OrcaPaymentPage.getString(requiredFieldsDict, "required_field", ""),
      display_name: Utils$OrcaPaymentPage.getString(requiredFieldsDict, "display_name", ""),
      field_type: PaymentMethodsRecord$OrcaPaymentPage.getFieldType(requiredFieldsDict, isBancontact),
      value: Utils$OrcaPaymentPage.getString(requiredFieldsDict, "value", "")
    };
  });
}

function getCardNetworks(networksArr) {
  return Belt_Array.keepMap(networksArr, Core__JSON.Decode.object).map(dict => ({
    cardNetwork: CardUtils$OrcaPaymentPage.getCardType(Utils$OrcaPaymentPage.getString(dict, "card_network", "")),
    surchargeDetails: PaymentMethodsRecord$OrcaPaymentPage.getSurchargeDetails(dict),
    eligibleConnectors: Utils$OrcaPaymentPage.getStrArray(dict, "eligible_connectors")
  }));
}

function itemToPaymentsEnabledMapper(methodsArray) {
  return Belt_Array.keepMap(methodsArray, Core__JSON.Decode.object).map(dict => {
    let paymentMethodSubtype = Utils$OrcaPaymentPage.getString(dict, "payment_method_subtype", "");
    return {
      cardNetworks: getCardNetworks(Utils$OrcaPaymentPage.getArray(dict, "card_networks")),
      paymentMethodType: Utils$OrcaPaymentPage.getString(dict, "payment_method_type", ""),
      paymentMethodSubtype: paymentMethodSubtype,
      bankNames: Utils$OrcaPaymentPage.getStrArray(dict, "bank_names"),
      requiredFields: getDynamicFieldsFromJsonDictV2(dict, paymentMethodSubtype === "bancontact_card"),
      surchargeDetails: PaymentMethodsRecord$OrcaPaymentPage.getSurchargeDetails(dict),
      paymentExperience: Utils$OrcaPaymentPage.getArray(dict, "payment_experience").map(item => PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceType(Core__Option.getOr(Core__JSON.Decode.string(item), "")))
    };
  });
}

function itemToPaymentsObjMapper(customerDict) {
  return {
    paymentMethodsEnabled: itemToPaymentsEnabledMapper(Utils$OrcaPaymentPage.getArray(customerDict, "payment_methods_enabled")),
    customerPaymentMethods: itemToCustomerMapper(Utils$OrcaPaymentPage.getArray(customerDict, "customer_payment_methods"))
  };
}

function createPaymentsObjArr(dict, key) {
  let customerDict = Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), {});
  let finalList = itemToPaymentsObjMapper(customerDict);
  return {
    TAG: "LoadedV2",
    _0: finalList
  };
}

function itemToPaymentDetails(dict) {
  let cardDict = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(dict, "payment_method_data"), "card");
  return {
    paymentToken: Utils$OrcaPaymentPage.getString(dict, "payment_method_token", ""),
    customerId: Utils$OrcaPaymentPage.getString(dict, "customer_id", ""),
    paymentMethodType: Utils$OrcaPaymentPage.getString(dict, "payment_method_type", ""),
    paymentMethodSubType: Utils$OrcaPaymentPage.getString(dict, "payment_method_subtype", ""),
    recurringEnabled: Utils$OrcaPaymentPage.getBool(dict, "recurring_enabled", false),
    paymentMethodData: {
      card: getCardDetails(cardDict)
    },
    isDefault: Utils$OrcaPaymentPage.getBool(dict, "is_default", false),
    requiresCvv: Utils$OrcaPaymentPage.getBool(dict, "requires_cvv", false),
    lastUsedAt: Utils$OrcaPaymentPage.getString(dict, "last_used_at", ""),
    created: Utils$OrcaPaymentPage.getString(dict, "created", ""),
    bank: {
      mask: ""
    }
  };
}

function itemToPaymentMethodsUpdateMapper(dict) {
  let cardDict = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(dict, "payment_method_data"), "card");
  return {
    associatedPaymentMethods: PaymentConfirmTypesV2$OrcaPaymentPage.getAssociatedPaymentMethods(dict),
    paymentMethodData: {
      card: getCardDetails(cardDict)
    }
  };
}

let defaultAddress = {
  city: "",
  country: "",
  line1: "",
  line2: "",
  line3: "",
  zip: "",
  state: "",
  firstName: "",
  lastName: ""
};

let defaultBilling_phone = {
  number: "",
  countryCode: ""
};

let defaultBilling = {
  address: defaultAddress,
  phone: defaultBilling_phone,
  email: ""
};

let defaultPaymentMethods_requiredFields = [];

let defaultPaymentMethods_paymentExperience = [];

let defaultPaymentMethods = {
  paymentMethodType: "",
  paymentMethodSubtype: "",
  requiredFields: defaultPaymentMethods_requiredFields,
  surchargeDetails: undefined,
  paymentExperience: defaultPaymentMethods_paymentExperience
};

let defaultCustomerMethods = {
  paymentToken: "",
  customerId: "",
  paymentMethodType: "",
  paymentMethodSubType: "",
  recurringEnabled: false,
  paymentMethodData: {
    card: {
      network: undefined,
      last4Digits: "",
      expiryMonth: "",
      expiryYear: "",
      cardHolderName: undefined,
      nickname: undefined,
      issuerCountry: undefined,
      cardFingerprint: "",
      cardIsin: "",
      cardIssuer: "",
      cardType: "",
      savedToLocker: false
    }
  },
  isDefault: false,
  requiresCvv: false,
  lastUsedAt: "",
  created: "",
  bank: {
    mask: ""
  }
};

let defaultPaymentsList_paymentMethodsEnabled = [defaultPaymentMethods];

let defaultPaymentsList_customerPaymentMethods = [defaultCustomerMethods];

let defaultPaymentsList = {
  paymentMethodsEnabled: defaultPaymentsList_paymentMethodsEnabled,
  customerPaymentMethods: defaultPaymentsList_customerPaymentMethods
};

export {
  getCardDetails,
  itemToCustomerMapper,
  getDynamicFieldsFromJsonDictV2,
  getCardNetworks,
  itemToPaymentsEnabledMapper,
  itemToPaymentsObjMapper,
  createPaymentsObjArr,
  itemToPaymentDetails,
  itemToPaymentMethodsUpdateMapper,
  defaultAddress,
  defaultBilling,
  defaultPaymentMethods,
  defaultCustomerMethods,
  defaultPaymentsList,
}
/* Utils-OrcaPaymentPage Not a pure module */
